import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectUser, useUserActions, selectGreenhouse } from 'state';
import { Modal } from 'components/_shared/Modal';
import { Button } from 'components/_shared/Button';
import { Logo } from 'components/Logo';
import { Menu, ProfileMenu } from './Menu';
import { StyledHeader, ButtonWrapper } from './Header.styles';
import { API } from '../../api';

export const Header = memo(function ({ ...props }) {
  const user = useSelector(selectUser);
  const { logout, toggleLogoutModal } = useUserActions();
  const { selectedGreenhouse } = useSelector(selectGreenhouse);
  const handleLogOut = () => logout();
  const [alertsCount, setAlertsCount] = useState();
  const [zones, setZones] = useState([]);

  const getZones = () => {
    API.zone.getZone().then(({ data }) => {
      setZones(data);
    });
  };

  const getAlertsCount = (customer, location) => {
    API.alert.getAlertLogsCount(customer, location).then(({ data }) => {
      setAlertsCount(data.count);
    });
  };
  useEffect(() => {
    if (user?.customer?.[0]?.external_id && selectedGreenhouse) {
      getAlertsCount(user?.customer?.[0]?.external_id, selectedGreenhouse);
      getZones();
    }
  }, [user, selectedGreenhouse]);
  return (
    <StyledHeader {...props}>
      <Logo />
      <Menu
        partner={user.partner_name}
        customer={user.customer_name}
        alertsCount={props.alertsCount ?? alertsCount}
        zones={zones}
      />
      <ProfileMenu text={user.email} />
      {user.isShowLogoutModal && (
        <Modal
          header='Are you sure to log out from account?'
          textCenter={true}
          close={toggleLogoutModal}
        >
          <ButtonWrapper>
            <Button variant='secondary' onClick={toggleLogoutModal}>
              Cancel
            </Button>
            <Button variant='primary' onClick={handleLogOut}>
              Yes, log out
            </Button>
          </ButtonWrapper>
        </Modal>
      )}
    </StyledHeader>
  );
});
